import React, { useState } from 'react';
import { ArrowLeft, Zap, Filter } from 'lucide-react';
import { Drop } from '../../types';
import { DropCard } from '../DropCard';
import { FilterModal } from '../FilterModal';
import { useToast } from '../ToastContext';
interface DropsScreenProps {
  onBack: () => void;
  onDropClick: (drop: Drop) => void;
}
export function DropsScreen({
  onBack,
  onDropClick
}: DropsScreenProps) {
  const [activeFilter, setActiveFilter] = useState<'all' | 'live' | 'upcoming'>('all');
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const {
    showToast
  } = useToast();
  // Expanded drops data with 20 items
  const drops: Drop[] = [{
    id: '1',
    brandName: 'Nike',
    brandLogo: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=100&h=100&fit=crop',
    itemName: 'Free Nike Dri-FIT Socks',
    itemImage: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?w=800&h=600&fit=crop',
    description: 'Premium performance socks with moisture-wicking technology',
    value: 599,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 12,
    category: 'Sportswear',
    participatingStores: [{
      id: '1',
      name: 'Nike Store - Koramangala',
      address: '100 Feet Road',
      distance: '0.5 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Nike Store - Indiranagar',
      address: '12th Main Road',
      distance: '1.2 km',
      isOpen: true
    }, {
      id: '3',
      name: 'Nike Store - MG Road',
      address: 'Brigade Road',
      distance: '2.1 km',
      isOpen: true
    }],
    terms: ['Valid only at participating stores', 'Must be redeemed within 30 minutes of unlocking', 'One drop per user', 'Cannot be combined with other offers']
  }, {
    id: '2',
    brandName: 'Coca-Cola',
    brandLogo: 'https://images.unsplash.com/photo-1554866585-cd94860890b7?w=100&h=100&fit=crop',
    itemName: 'Free Coke Zero Can',
    itemImage: 'https://images.unsplash.com/photo-1554866585-cd94860890b7?w=800&h=600&fit=crop',
    description: 'Refreshing zero-sugar cola, ice cold',
    value: 40,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 8,
    category: 'Food & Beverage',
    participatingStores: [{
      id: '1',
      name: 'Cafe Coffee Day - Koramangala',
      address: '5th Block',
      distance: '0.3 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Starbucks - Indiranagar',
      address: '100 Feet Road',
      distance: '0.8 km',
      isOpen: true
    }],
    terms: ['Valid at participating cafes and restaurants', 'Must be redeemed today', 'One can per customer']
  }, {
    id: '3',
    brandName: "McDonald's",
    brandLogo: 'https://images.unsplash.com/photo-1619454016518-697bc231e7cb?w=100&h=100&fit=crop',
    itemName: 'Free McFlurry',
    itemImage: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=800&h=600&fit=crop',
    description: 'Creamy soft serve with your choice of mix-in',
    value: 120,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 15,
    category: 'Food & Beverage',
    participatingStores: [{
      id: '1',
      name: "McDonald's - Koramangala",
      address: 'Forum Mall',
      distance: '0.6 km',
      isOpen: true
    }, {
      id: '2',
      name: "McDonald's - Indiranagar",
      address: 'CMH Road',
      distance: '1.5 km',
      isOpen: true
    }],
    terms: ["Valid at participating McDonald's outlets", 'Choose any McFlurry flavor', 'Valid for dine-in and takeaway']
  }, {
    id: '4',
    brandName: 'Adidas',
    brandLogo: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?w=100&h=100&fit=crop',
    itemName: 'Free Gym Bag',
    itemImage: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&h=600&fit=crop',
    description: 'Durable sports bag with multiple compartments',
    value: 1299,
    startTime: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 7,
    category: 'Sportswear',
    participatingStores: [{
      id: '1',
      name: 'Adidas Store - MG Road',
      address: 'Garuda Mall',
      distance: '2.0 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Adidas Store - Whitefield',
      address: 'Phoenix Marketcity',
      distance: '8.5 km',
      isOpen: true
    }],
    terms: ['Available from 2 PM today', 'Limited quantity available', 'Valid at Adidas brand stores only']
  }, {
    id: '5',
    brandName: 'Samsung',
    brandLogo: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=100&h=100&fit=crop',
    itemName: 'Free Galaxy Buds Case',
    itemImage: 'https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=800&h=600&fit=crop',
    description: 'Premium protective case for Galaxy Buds',
    value: 999,
    startTime: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 10 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 3,
    category: 'Technology',
    participatingStores: [{
      id: '1',
      name: 'Samsung Store - Koramangala',
      address: 'Sony World Junction',
      distance: '1.0 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Samsung Store - MG Road',
      address: 'Sigma Central Mall',
      distance: '2.5 km',
      isOpen: true
    }],
    terms: ['Available from 6 PM today', 'Compatible with Galaxy Buds and Buds+', 'While stocks last']
  }, {
    id: '6',
    brandName: 'Puma',
    brandLogo: 'https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=100&h=100&fit=crop',
    itemName: 'Free Gym Towel',
    itemImage: 'https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=800&h=600&fit=crop',
    description: 'Soft microfiber gym towel with Puma logo',
    value: 399,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 9,
    category: 'Sportswear',
    participatingStores: [{
      id: '1',
      name: 'Puma Store - Koramangala',
      address: 'Forum Mall',
      distance: '0.7 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Puma Store - Indiranagar',
      address: 'CMH Road',
      distance: '1.3 km',
      isOpen: true
    }],
    terms: ['Valid at Puma stores only', 'One towel per customer', 'While stocks last']
  }, {
    id: '7',
    brandName: 'Starbucks',
    brandLogo: 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=100&h=100&fit=crop',
    itemName: 'Free Cookie',
    itemImage: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=800&h=600&fit=crop',
    description: 'Freshly baked chocolate chip cookie',
    value: 150,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 6 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 11,
    category: 'Food & Beverage',
    participatingStores: [{
      id: '1',
      name: 'Starbucks - Koramangala',
      address: '80 Feet Road',
      distance: '0.4 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Starbucks - MG Road',
      address: 'Brigade Road',
      distance: '1.8 km',
      isOpen: true
    }],
    terms: ['Valid with any beverage purchase', 'Cannot be redeemed for cash', 'One cookie per transaction']
  }, {
    id: '8',
    brandName: 'OnePlus',
    brandLogo: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=100&h=100&fit=crop',
    itemName: 'Free Phone Case',
    itemImage: 'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=800&h=600&fit=crop',
    description: 'Protective silicone case for OnePlus phones',
    value: 799,
    startTime: new Date(Date.now() + 1 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 7 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 5,
    category: 'Technology',
    participatingStores: [{
      id: '1',
      name: 'OnePlus Store - Koramangala',
      address: 'Forum Mall',
      distance: '0.6 km',
      isOpen: true
    }, {
      id: '2',
      name: 'OnePlus Store - Whitefield',
      address: 'Phoenix Marketcity',
      distance: '8.2 km',
      isOpen: true
    }],
    terms: ['Available from 1 PM today', 'Compatible with OnePlus 9 and above', 'Limited stock']
  }, {
    id: '9',
    brandName: "Levi's",
    brandLogo: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=100&h=100&fit=crop',
    itemName: 'Free Leather Belt',
    itemImage: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&h=600&fit=crop',
    description: 'Genuine leather belt with classic buckle',
    value: 1299,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 6,
    category: 'Fashion',
    participatingStores: [{
      id: '1',
      name: "Levi's Store - MG Road",
      address: 'Garuda Mall',
      distance: '1.9 km',
      isOpen: true
    }, {
      id: '2',
      name: "Levi's Store - Whitefield",
      address: 'Phoenix Marketcity',
      distance: '8.0 km',
      isOpen: true
    }],
    terms: ['Valid with jeans purchase', 'Available in black and brown', 'One belt per customer']
  }, {
    id: '10',
    brandName: 'Reebok',
    brandLogo: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=100&h=100&fit=crop',
    itemName: 'Free Water Bottle',
    itemImage: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=800&h=600&fit=crop',
    description: 'BPA-free sports water bottle, 750ml',
    value: 499,
    startTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 8,
    category: 'Sportswear',
    participatingStores: [{
      id: '1',
      name: 'Reebok Store - Koramangala',
      address: 'Forum Mall',
      distance: '0.7 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Reebok Store - Indiranagar',
      address: '100 Feet Road',
      distance: '1.4 km',
      isOpen: true
    }],
    terms: ['Available from 3 PM today', 'One bottle per customer', 'While stocks last']
  }, {
    id: '11',
    brandName: 'Dominos',
    brandLogo: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=100&h=100&fit=crop',
    itemName: 'Free Garlic Bread',
    itemImage: 'https://images.unsplash.com/photo-1619454016518-697bc231e7cb?w=800&h=600&fit=crop',
    description: 'Freshly baked garlic breadsticks with cheese',
    value: 99,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 18,
    category: 'Food & Beverage',
    participatingStores: [{
      id: '1',
      name: 'Dominos - Koramangala',
      address: '5th Block',
      distance: '0.3 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Dominos - Indiranagar',
      address: '12th Main',
      distance: '1.1 km',
      isOpen: true
    }],
    terms: ['Valid with any pizza order', 'Dine-in and delivery', 'One order per customer']
  }, {
    id: '12',
    brandName: 'JBL',
    brandLogo: 'https://images.unsplash.com/photo-1545127398-14699f92334b?w=100&h=100&fit=crop',
    itemName: 'Free Earbuds Pouch',
    itemImage: 'https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=800&h=600&fit=crop',
    description: 'Protective carrying case for wireless earbuds',
    value: 599,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 7,
    category: 'Technology',
    participatingStores: [{
      id: '1',
      name: 'JBL Store - MG Road',
      address: 'Garuda Mall',
      distance: '1.8 km',
      isOpen: true
    }, {
      id: '2',
      name: 'JBL Store - Whitefield',
      address: 'Phoenix Marketcity',
      distance: '8.3 km',
      isOpen: true
    }],
    terms: ['Valid at JBL stores only', 'Compatible with most earbuds', 'While stocks last']
  }, {
    id: '13',
    brandName: 'H&M',
    brandLogo: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=100&h=100&fit=crop',
    itemName: 'Free Tote Bag',
    itemImage: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=800&h=600&fit=crop',
    description: 'Reusable canvas tote bag with H&M logo',
    value: 299,
    startTime: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 4,
    category: 'Fashion',
    participatingStores: [{
      id: '1',
      name: 'H&M - MG Road',
      address: 'Garuda Mall',
      distance: '1.9 km',
      isOpen: true
    }, {
      id: '2',
      name: 'H&M - Whitefield',
      address: 'Phoenix Marketcity',
      distance: '8.1 km',
      isOpen: true
    }],
    terms: ['Available from 2 PM today', 'With purchase of ₹2000 or more', 'Limited quantity']
  }, {
    id: '14',
    brandName: 'KFC',
    brandLogo: 'https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?w=100&h=100&fit=crop',
    itemName: 'Free Coleslaw',
    itemImage: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&h=600&fit=crop',
    description: 'Fresh and creamy coleslaw side dish',
    value: 89,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 14,
    category: 'Food & Beverage',
    participatingStores: [{
      id: '1',
      name: 'KFC - Koramangala',
      address: 'Forum Mall',
      distance: '0.6 km',
      isOpen: true
    }, {
      id: '2',
      name: 'KFC - Indiranagar',
      address: 'CMH Road',
      distance: '1.2 km',
      isOpen: true
    }],
    terms: ['Valid with any meal', 'Dine-in and takeaway', 'One per order']
  }, {
    id: '15',
    brandName: 'Decathlon',
    brandLogo: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?w=100&h=100&fit=crop',
    itemName: 'Free Resistance Band',
    itemImage: 'https://images.unsplash.com/photo-1598289431512-b97b0917affc?w=800&h=600&fit=crop',
    description: 'Medium resistance exercise band for workouts',
    value: 299,
    startTime: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 11 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 3,
    category: 'Sportswear',
    participatingStores: [{
      id: '1',
      name: 'Decathlon - Sarjapur Road',
      address: 'Outer Ring Road',
      distance: '5.2 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Decathlon - Whitefield',
      address: 'Varthur Main Road',
      distance: '9.1 km',
      isOpen: true
    }],
    terms: ['Available from 5 PM today', 'One band per customer', 'While stocks last']
  }, {
    id: '16',
    brandName: 'Boat',
    brandLogo: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=100&h=100&fit=crop',
    itemName: 'Free Charging Cable',
    itemImage: 'https://images.unsplash.com/photo-1583863788434-e58a36330cf0?w=800&h=600&fit=crop',
    description: 'Durable USB-C charging cable, 1 meter',
    value: 399,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 10,
    category: 'Technology',
    participatingStores: [{
      id: '1',
      name: 'Boat Store - Koramangala',
      address: 'Forum Mall',
      distance: '0.6 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Boat Store - MG Road',
      address: 'Garuda Mall',
      distance: '1.9 km',
      isOpen: true
    }],
    terms: ['Valid at Boat stores only', 'Fast charging compatible', 'One cable per customer']
  }, {
    id: '17',
    brandName: 'Zara',
    brandLogo: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=100&h=100&fit=crop',
    itemName: 'Free Scarf',
    itemImage: 'https://images.unsplash.com/photo-1520903920243-00d872a2d1c9?w=800&h=600&fit=crop',
    description: 'Lightweight cotton scarf in assorted colors',
    value: 899,
    startTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 2,
    category: 'Fashion',
    participatingStores: [{
      id: '1',
      name: 'Zara - MG Road',
      address: 'UB City Mall',
      distance: '2.3 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Zara - Whitefield',
      address: 'Phoenix Marketcity',
      distance: '8.4 km',
      isOpen: true
    }],
    terms: ['Available from 3 PM today', 'With purchase of ₹3000 or more', 'Subject to availability']
  }, {
    id: '18',
    brandName: 'Nivea',
    brandLogo: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=100&h=100&fit=crop',
    itemName: 'Free Face Wash Sample',
    itemImage: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=800&h=600&fit=crop',
    description: 'Travel-size face wash, 50ml',
    value: 149,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 6 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 16,
    category: 'Beauty',
    participatingStores: [{
      id: '1',
      name: 'Health & Glow - Koramangala',
      address: '100 Feet Road',
      distance: '0.5 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Health & Glow - Indiranagar',
      address: '12th Main',
      distance: '1.3 km',
      isOpen: true
    }],
    terms: ['Valid at participating stores', 'One sample per customer', 'While stocks last']
  }, {
    id: '19',
    brandName: 'Gillette',
    brandLogo: 'https://images.unsplash.com/photo-1621607512214-68297480165e?w=100&h=100&fit=crop',
    itemName: 'Free Razor',
    itemImage: 'https://images.unsplash.com/photo-1499728603263-13726abce5fd?w=800&h=600&fit=crop',
    description: 'Single-blade disposable razor',
    value: 99,
    startTime: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    endTime: new Date(Date.now() + 10 * 60 * 60 * 1000).toISOString(),
    status: 'upcoming',
    storesNearby: 12,
    category: 'Beauty',
    participatingStores: [{
      id: '1',
      name: 'Big Bazaar - Koramangala',
      address: 'Forum Mall',
      distance: '0.6 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Big Bazaar - Whitefield',
      address: 'Phoenix Marketcity',
      distance: '8.2 km',
      isOpen: true
    }],
    terms: ['Available from 4 PM today', 'One razor per customer', 'Valid at participating retailers']
  }, {
    id: '20',
    brandName: 'Lakme',
    brandLogo: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=100&h=100&fit=crop',
    itemName: 'Free Lipstick Sample',
    itemImage: 'https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=800&h=600&fit=crop',
    description: 'Mini lipstick in trending shade',
    value: 199,
    startTime: new Date().toISOString(),
    endTime: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(),
    status: 'live',
    storesNearby: 13,
    category: 'Beauty',
    participatingStores: [{
      id: '1',
      name: 'Lakme Salon - Koramangala',
      address: '80 Feet Road',
      distance: '0.4 km',
      isOpen: true
    }, {
      id: '2',
      name: 'Lakme Salon - Indiranagar',
      address: '100 Feet Road',
      distance: '1.2 km',
      isOpen: true
    }],
    terms: ['Valid at Lakme salons only', 'One sample per customer', 'Subject to availability']
  }];
  // Calculate category counts
  const categoryCounts = drops.reduce((acc, drop) => {
    acc[drop.category] = (acc[drop.category] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);
  // Filter drops by status and category
  const filteredDrops = drops.filter(drop => {
    // Status filter
    if (activeFilter !== 'all' && drop.status !== activeFilter) return false;
    // Category filter
    if (selectedCategories.length > 0 && !selectedCategories.includes(drop.category)) return false;
    return true;
  });
  const liveCount = drops.filter(d => d.status === 'live').length;
  const upcomingCount = drops.filter(d => d.status === 'upcoming').length;
  const handleSetReminder = (drop: Drop) => {
    showToast(`Reminder set for ${drop.itemName}! 🔔`, 'success');
  };
  const handleCategoryToggle = (category: string) => {
    setSelectedCategories(prev => prev.includes(category) ? prev.filter(c => c !== category) : [...prev, category]);
  };
  const handleClearFilters = () => {
    setSelectedCategories([]);
  };
  const handleApplyFilters = () => {
    setIsFilterModalOpen(false);
    if (selectedCategories.length > 0) {
      showToast(`Filtered by ${selectedCategories.length} ${selectedCategories.length === 1 ? 'category' : 'categories'}`, 'success');
    }
  };
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-634">
      {/* Header */}
      <div className="bg-[#9D00FF] px-5 py-6 sticky top-0 z-10" data-id="element-635">
        <div className="flex items-center gap-3 mb-4" data-id="element-636">
          <button onClick={onBack} className="w-12 h-12 bg-[#E6FF00] rounded-full flex items-center justify-center shadow-lg active:scale-95 transition-transform" data-id="element-637">
            <ArrowLeft size={24} className="text-gray-900" strokeWidth={2.5} data-id="element-638" />
          </button>
          <div className="flex-1" data-id="element-639">
            <h1 className="text-2xl font-bold text-white" data-id="element-640">Drops</h1>
            <p className="text-sm text-white/80" data-id="element-641">Free items from top brands</p>
          </div>
          <button onClick={() => setIsFilterModalOpen(true)} className="relative w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors" data-id="element-642">
            <Filter size={20} className="text-white" data-id="element-643" />
            {selectedCategories.length > 0 && <div className="absolute -top-1 -right-1 w-5 h-5 bg-[#FFFC00] rounded-full flex items-center justify-center" data-id="element-644">
                <span className="text-xs font-bold text-black" data-id="element-645">
                  {selectedCategories.length}
                </span>
              </div>}
          </button>
        </div>

        {/* Filter Tabs */}
        <div className="flex gap-2" data-id="element-646">
          <button onClick={() => setActiveFilter('all')} className={`flex-1 py-2.5 rounded-xl font-medium text-sm transition-all duration-100 border-[3px] border-black ${activeFilter === 'all' ? 'bg-[#FFFC00] text-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px]' : 'bg-white/10 text-white backdrop-blur-sm shadow-[2px_2px_0px_0px_rgba(0,0,0,0.4)]'}`} data-id="element-647">
            All ({drops.length})
          </button>
          <button onClick={() => setActiveFilter('live')} className={`flex-1 py-2.5 rounded-xl font-medium text-sm transition-all duration-100 flex items-center justify-center gap-1.5 border-[3px] border-black ${activeFilter === 'live' ? 'bg-green-500 text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px]' : 'bg-white/10 text-white backdrop-blur-sm shadow-[2px_2px_0px_0px_rgba(0,0,0,0.4)]'}`} data-id="element-648">
            {activeFilter === 'live' && <Zap size={14} data-id="element-649" />}
            Live ({liveCount})
          </button>
          <button onClick={() => setActiveFilter('upcoming')} className={`flex-1 py-2.5 rounded-xl font-medium text-sm transition-all duration-100 border-[3px] border-black ${activeFilter === 'upcoming' ? 'bg-red-500 text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px]' : 'bg-white/10 text-white backdrop-blur-sm shadow-[2px_2px_0px_0px_rgba(0,0,0,0.4)]'}`} data-id="element-650">
            Soon ({upcomingCount})
          </button>
        </div>
      </div>

      {/* Active Filters Display */}
      {selectedCategories.length > 0 && <div className="px-5 pt-4 pb-2" data-id="element-651">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-652">
            <span className="text-sm text-gray-600" data-id="element-653">Filtered by:</span>
            {selectedCategories.map(category => <button key={category} onClick={() => handleCategoryToggle(category)} className="px-3 py-1 bg-[#9D00FF] text-white text-sm rounded-full flex items-center gap-1.5 hover:bg-[#8800DD] transition-colors" data-id="element-654">
                {category}
                <span className="text-lg leading-none" data-id="element-655">×</span>
              </button>)}
            <button onClick={handleClearFilters} className="text-sm text-gray-500 hover:text-gray-700 underline" data-id="element-656">
              Clear all
            </button>
          </div>
        </div>}

      {/* Drops List */}
      <div className="px-5 py-4 space-y-4" data-id="element-657">
        {filteredDrops.length === 0 ? <div className="text-center py-12" data-id="element-658">
            <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-659">
              <Zap size={32} className="text-gray-400" data-id="element-660" />
            </div>
            <h3 className="font-bold text-gray-900 mb-1" data-id="element-661">No drops found</h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-662">
              Try adjusting your filters
            </p>
            <button onClick={handleClearFilters} className="text-sm text-[#9D00FF] font-medium hover:underline" data-id="element-663">
              Clear all filters
            </button>
          </div> : filteredDrops.map(drop => <DropCard key={drop.id} drop={drop} onClick={() => onDropClick(drop)} onSetReminder={() => handleSetReminder(drop)} data-id="element-664" />)}
      </div>

      {/* Info Banner */}
      <div className="mx-5 mt-6 bg-purple-50 border border-purple-200 rounded-xl p-4" data-id="element-665">
        <div className="flex items-start gap-3" data-id="element-666">
          <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-667">
            <Zap size={16} className="text-white" data-id="element-668" />
          </div>
          <div className="flex-1" data-id="element-669">
            <h3 className="font-bold text-purple-900 mb-1" data-id="element-670">How Drops Work</h3>
            <p className="text-sm text-purple-700" data-id="element-671">
              Visit a participating store, tap "I'm Here" to unlock your free
              item. You can apply it to your order or gift it to a friend!
            </p>
          </div>
        </div>
      </div>

      {/* Filter Modal */}
      <FilterModal isOpen={isFilterModalOpen} onClose={() => setIsFilterModalOpen(false)} selectedCategories={selectedCategories} onCategoryToggle={handleCategoryToggle} onClearAll={handleClearFilters} onApply={handleApplyFilters} categoryCounts={categoryCounts} data-id="element-672" />
    </div>;
}